export default {
  despesaTipoID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  dataDespesa: {
    value: null,
    maxlength: '10',
    required: true,
    state: null,
    disabled: true
  },
  quantidade: {
    value: 0,
    maxlength: '10',
    required: true,
    state: null,
    disabled: true
  },
  valorUnitario: {
    value: 0,
    maxlength: '20',
    required: true,
    state: null,
    disabled: true
  },
  total: {
    value: 0,
    maxlength: '20',
    required: false,
    state: null,
    disabled: true
  },
  observacao: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '2',
    noResize: true
  },
  paisOrigemID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  paisDestinoID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  estadoOrigemID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  estadoDestinoID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  cidadeOrigemID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  cidadeDestinoID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  km: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  dataInicioVoo: {
    value: null,
    maxlength: '10',
    required: false,
    state: null,
    disabled: true
  },
  dataFimVoo: {
    value: null,
    maxlength: '10',
    required: false,
    state: null,
    disabled: true
  },
  tipoPassagemVoo: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/travelrefund/details/components/modal/debt/modalDebt-form.js